export const vippsWidget = {
    notNow: 'Ikke nå',
    openVipps: 'Åpne Vipps-appen',
    header: 'Nå kan du tæppe med Vipps – i hele verden',
    text1: 'Hold mobilen din inntil kortterminalen, og vipps, så har du betalt. Kjapt, sikkert og veldig enkelt – fra Norge til Nepal.',
    text2: 'Gå til Vipps-appen for å sette opp trådløs betaling med bankkortet ditt.',
} as const;
